export default __webpack_public_path__ + "static/media/desktop-step-1.7acd3f4d.jpg";